import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { H2 } from "../../atomic/atoms/type/H2"
import { TYPE, COLORS } from "../../../theme/styles/globals"
import { ALIGN } from "../globals"

export default class ContentfulBlockServiceList extends React.Component {
  render() {
    const { align, title, list, mode, number } = this.props

    return (
      <Container mode={mode} align={align}>
        <Wrap>
          <Accent mode={mode}>0{number}</Accent>
          <Title mode={mode}>{title}</Title>
          <List>
            {list.map((item, i) => (
              <ListItem key={i}>{item}</ListItem>
            ))}
          </List>
        </Wrap>
      </Container>
    )
  }
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  ${props =>
    props.mode === "LIGHT"
      ? `color:${COLORS.LIGHT_GREY_2};`
      : `color:${COLORS.LIGHT_GREY_4};`};

  ${up("md")} {
    padding-top: 0px;
    padding-bottom: 0px;
    border-left: 1px dashed
      ${props =>
        props.mode === "LIGHT" ? COLORS.LIGHT_GREY_2 : COLORS.LIGHT_GREY_4};
    width: 530px;

    ${props =>
      props.align === ALIGN.BOTTOM
        ? `
      align-items:center;
      align-content:center;
      justify-content:center;
      padding-top:150px;
    `
        : ``}

    ${props =>
      props.align === ALIGN.MIDDLE
        ? `
      align-items:center;
      align-content:center;
      justify-content:center;
    `
        : ``}
  }
`

const Wrap = styled.div`
  margin-bottom: 80px;
  width: 100%;

  ${up("md")} {
    margin-bottom: 0px;
  }
`

const Title = styled(H2)`
  ${props =>
    props.mode === "LIGHT"
      ? `color:${COLORS.DARK_GREY_3};`
      : `color:${COLORS.WHITE};`};
  font-size: 32px;
  line-height: 32px;

  ${up("md")} {
    width: 80%;
    font-size: 72px;
    line-height: 72px;
  }

  &:after {
    content: " ";
    display: block;
    width: 100%;
    height: 6px;
    margin-top: 40px;
    margin-bottom: 40px;
    ${props =>
      props.mode === "LIGHT"
        ? `background-color:${COLORS.DARK_GREY_3};`
        : `background-color:${COLORS.WHITE};`};
  }
`

const List = styled.ul`
  padding-left: 22px;
`

const ListItem = styled.li`
  line-height: 24px;
  font-size: 16px;
  font-family: ${TYPE.SERIF_FONT};
  color: ${COLORS.LIGHT_GREY_2};
`

const Accent = styled.p`
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  display: block;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
  margin-bottom: 18px;

  ${up("md")} {
    margin-bottom: 34px;
  }

  &::before {
    content: " ";
    width: 80px;
    height: 1px;
    background-color: ${props =>
      props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
    display: inline-block;
    margin-right: 20px;
    transform: translate(0px, -3px);
  }
`
